import { render, staticRenderFns } from "./ImageSlide.vue?vue&type=template&id=225b05e5&"
import script from "./ImageSlide.vue?vue&type=script&lang=js&"
export * from "./ImageSlide.vue?vue&type=script&lang=js&"
import style0 from "./ImageSlide.vue?vue&type=style&index=0&id=225b05e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports